@import '../../../../../../../constants/spacing.module.less';

.scan-input-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
  gap: @space-8;
}

.scan-input {
  height: 32px;
  width: 100%;
  font-size: 14px;
}

.autocomplete-scanner-icon {
  display: flex;
  align-items: center;
  height: 16px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  svg {
    height: 24px;
    width: 24px;
  }
}
